var defaultStyles = {
  "root": "Base-Radio",
  "input": "Base-Radio--Input",
  "hover": "Base-Radio--Hover",
  "no_hover": "Base-Radio--NoHover",
  "label": "Base-Radio--Label",
  "radio": "Base-Radio--Radio",
  "sm": "Base-Radio--Sm",
  "md": "Base-Radio--Md",
  "lg": "Base-Radio--Lg",
  "radio_checked": "Base-Radio--RadioChecked",
  "radio_inactive": "Base-Radio--RadioInactive",
  "radio_disabled": "Base-Radio--RadioDisabled",
  "radio_active": "Base-Radio--RadioActive",
  "content": "Base-Radio--Content",
  "disabled": "Base-Radio--Disabled",
  "hint": "Base-Radio--Hint",
  "after": "Base-Radio--After",
  "boxed": "Base-Radio--Boxed",
  "button": "Base-Radio--Button",
  "checked": "Base-Radio--Checked",
  "button_inner": "Base-Radio--ButtonInner",
  "group": "Base-Radio--Group",
  "vertical": "Base-Radio--Vertical",
  "group_button": "Base-Radio--GroupButton",
  "wrapper": "Base-Radio--Wrapper"
};

export { defaultStyles as default };
